var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 3.75H5.625C5.12772 3.75 4.65081 3.94754 4.29917 4.29917C3.94754 4.65081 3.75 5.12772 3.75 5.625V24.375C3.75 24.8723 3.94754 25.3492 4.29917 25.7008C4.65081 26.0525 5.12772 26.25 5.625 26.25H24.375C24.8723 26.25 25.3492 26.0525 25.7008 25.7008C26.0525 25.3492 26.25 24.8723 26.25 24.375V5.625C26.25 5.12772 26.0525 4.65081 25.7008 4.29917C25.3492 3.94754 24.8723 3.75 24.375 3.75V3.75ZM15 7.5C15.2781 7.5 15.55 7.58247 15.7813 7.737C16.0125 7.89152 16.1928 8.11114 16.2992 8.3681C16.4056 8.62506 16.4335 8.90781 16.3792 9.1806C16.325 9.45338 16.191 9.70395 15.9944 9.90062C15.7977 10.0973 15.5471 10.2312 15.2743 10.2855C15.0016 10.3397 14.7188 10.3119 14.4619 10.2055C14.2049 10.099 13.9853 9.91878 13.8307 9.68752C13.6762 9.45626 13.5938 9.18438 13.5938 8.90625C13.5938 8.53329 13.7419 8.1756 14.0056 7.91188C14.2694 7.64816 14.627 7.5 15 7.5ZM18.75 22.6172H11.25V20.5078H13.9453V15.1172H12.1875V13.0078H16.0547V20.5078H18.75V22.6172Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.f98d2acf0175349abb9608965a7c9915.svg";
export { ForwardRef as ReactComponent };